import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ScrollTopModule } from 'primeng/scrolltop';
import { focusTarget } from '../../../utilities/accessibility';

@Component({
  selector: 'app-scroll-top-button',
  imports: [ReactiveFormsModule, CommonModule, ScrollTopModule],
  template: `
    <p-scrolltop
      (click.capture)="onScrollTopActivate()"
      behavior="auto"
      [buttonProps]="{
        rounded: true,
        severity: 'success',
        ariaLabel: 'Scroll to top of page',
        autofocus: false,
      }"
      [threshold]="200"
    />
  `,
  styles: `
    :host {
      --p-button-success-background: var(--sed-engaged-black-color);
      --p-button-success-border-color: var(--sed-engaged-black-color);
      --p-button-success-color: var(--sed-warm-white-color);
      --p-button-success-hover-background: var(--sed-sedgwick-green-color);
      --p-button-success-hover-border-color: var(--sed-engaged-black-color);
      --p-button-success-hover-color: var(--sed-engaged-black-color);
    }
  `,
})
export class ScrollTopButtonComponent {
  /**
   * Capture phase runs before PrimeNG scrolls and before the button unmounts
   * (scrollY < threshold). Moves NVDA off the floating button onto #top-of-page.
   */
  protected onScrollTopActivate(): void {
    focusTarget(document.getElementById('top-of-page'), { preventScroll: true });
  }
}
